import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const QuestionsContextMemorySpace = createContext();

export const QuestionsContext = ({ children }) => {
  const [question, setQuestion] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_STRAPI_QA}/categorias?eliminado=false`)
      .then((response) => {
        setQuestion(response.data);
      })
      .catch((error) => {
        // console.log("error", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <QuestionsContextMemorySpace.Provider
      value={{
        question,
        setQuestion,
        loading,
      }}
    >
      {children}
    </QuestionsContextMemorySpace.Provider>
  );
};
